import React, { PureComponent } from 'react';
import styled from 'styled-components';
import chunk from 'lodash.chunk';
import PropTypes from 'prop-types';
import {
	StyledSubNavListColumn,
	ColumnTitle,
} from './subNavStyles';
import transformHref from 'core/utils/transformHref';
import SubNavListItem from './SubNavListItem';

class SubNavListColumn extends PureComponent {
	render() {
		const { title, items, parentSlug, type, multiColumn } = this.props;
		// When the SubNav has multiple columns, let 10 be max for a single column
		// Otherwise, break into new column after 6 items
		const chunkSize = multiColumn ? 10 : 6;
		const listChunks = chunk(items, chunkSize);

		return (
			listChunks.map((col, colN) => {
				return (
					<StyledSubNavListColumn key={`dropdown-col-${colN}`}>
						{title && <ColumnTitle>{title}</ColumnTitle>}
						{col.map((item, n) => {
							return <SubNavListItem
								key={`dropdown-item-${colN}-${n}`}
								text={item.shortName ? item.shortName : item.category_name}
								href={item.href ? item.href : transformHref({ slug: item.slug, type: type })}
								parentSlug={parentSlug}
								item={item}
							/>;
						})}
					</StyledSubNavListColumn>
				);
			})
		);
	}

	static propTypes = {
		items: PropTypes.arrayOf(PropTypes.object),
		parentSlug: PropTypes.string.isRequired,
		type: PropTypes.string,
		title: PropTypes.string,
		multiColumn: PropTypes.bool,
	}

	static defaultProps = {
		type: "category",
		multiColumn: false,
	}
}

export default SubNavListColumn;
